/** @jsx jsx */
import { jsx } from '@emotion/react'
import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import axios from "axios";
import config from "../../Helpers/config.json";
import { errorMessages } from "../../Helpers/ErrorMessages";
import * as snackbarActions from '../../Redux/Actions/SnackbarActions/SnackbarActions'
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import { history } from "../../Helpers/history";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import { usePrint } from "../../Utils/Template/usePrint";
import { BackButton } from "../../Utils/Buttons/DataExportationButton";
import { ReusablePosTemplate } from "./ReusablePosTemplate";

const ProformaInvoiceReport = ({ actions, snackbars, match: { params } }) => {
    const [data, setData] = useState({ products: [], customer: {} });
    const [loading, setLoading] = useState('idle');
    const { id } = params;   // proforma invoice id from URL

    useEffect(() => {
        if (!id) return;

        setLoading('pending');

        axios.get(`${config.epharmUrl}/Cinvoice/proforma_invoice/${id}`)
            .then(response => {
                const res = response.data;
                if (res.status === 200 && res.data) {
                    const invoice = res.data;
                    setData({
                        products: invoice.products || [],
                        customer: {
                            ...invoice,
                            invoice_number: invoice.proforma_invoice_number,
                            customer_name: invoice.customer_name || "Walk-in Customer",
                            date: invoice.date,
                            total_amount: invoice.total_amount,
                            // You can add more fields if needed
                        }
                    });
                    setLoading('resolved');
                } else {
                    setLoading('rejected');
                }
            })
            .catch(error => {
                errorMessages(error, null, actions);
                setLoading('rejected');
            });
    }, [id, actions]);

    const handleCloseSnackbar = () => actions.snackbarActions.hideSnackBar();

    const { variant, message, open } = snackbars;
    const { products, customer } = data;
    const user_name = customer?.created_by_name || "Administrator";

    const { handlePrint, componentRef } = usePrint('');

    return (
        <div>
            <ReusableDashboardHeader 
                component="Proforma Invoice" 
                heading="Proforma" 
                subHeading="Proforma Invoice" 
                link={history.location.pathname}
            />

            <PharmacySnackbar 
                open={open} 
                variant={variant} 
                message={message} 
                handleCloseBar={handleCloseSnackbar} 
            />

            {loading === 'pending' ? (
                <div className="text-center mt-5">
                    <img src="/images/listPreloader.gif" alt="loader" style={{ width: '10%' }} />
                </div>
            ) : loading === 'resolved' ? (
                <div className="pos-invoice-style">
                    <div className='row'>
                        <div className='col-lg-8'>
                            <div className='mt-3'>
                                <BackButton to='/proforma-invoices' text='Back to Proforma List' />
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className="text-right mr-5">
                                <button 
                                    onClick={handlePrint} 
                                    className="btn pharmacy-info-btn mb-2 mr-2"
                                >
                                    Print Proforma
                                </button>
                            </div>
                        </div>
                    </div>

                    <div ref={componentRef} className="card styled-pos-card">
                        <ReusablePosTemplate 
                            customer={customer}
                            products={products}
                            user_name={user_name}
                            isProforma={true}     // ← Important flag
                        />
                    </div>
                </div>
            ) : (
                <div className="text-center mt-5 text-danger">
                    Failed to load Proforma Invoice
                </div>
            )}
        </div>
    );
};

function mapStateToProps(state) {
    return { snackbars: state.snackbars };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch)
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProformaInvoiceReport);